/**
 * 한국 공휴일 — Nager.Date 공개 API(키 불요, https://date.nager.at)로 연 단위 조회.
 * 설날·추석·대체공휴일까지 내려온다. localStorage에 연도별 캐시(공휴일은 연중 불변).
 * 네트워크 실패·스토리지 불가 시 조용히 빈 값 — 달력 강조가 빠질 뿐 기능은 그대로(점진적 향상).
 */

export type HolidayMap = Record<string, string> // 'YYYY-MM-DD' → 공휴일 이름

const CACHE_PREFIX = 'kr-holidays-v1-'

export async function fetchKrHolidays(years: number[]): Promise<HolidayMap> {
  const out: HolidayMap = {}
  await Promise.all(
    years.map(async (y) => {
      const cacheKey = `${CACHE_PREFIX}${y}`
      try {
        const cached = localStorage.getItem(cacheKey)
        if (cached) {
          Object.assign(out, JSON.parse(cached) as HolidayMap)
          return
        }
      } catch {
        /* 스토리지 접근 불가(사생활 모드 등) — 캐시 없이 진행 */
      }
      try {
        const res = await fetch(`https://date.nager.at/api/v3/PublicHolidays/${y}/KR`)
        if (!res.ok) return
        const list = (await res.json()) as { date: string; localName: string }[]
        const map: HolidayMap = {}
        for (const h of list) map[h.date] = h.localName
        Object.assign(out, map)
        try {
          localStorage.setItem(cacheKey, JSON.stringify(map))
        } catch {
          /* 캐시 실패는 무해 */
        }
      } catch {
        /* 오프라인 등 — 조용히 스킵 */
      }
    }),
  )
  return out
}
